export function isKnownKey<Key extends string>(
  key: string,
  definitions: Record<
    Key,
    {
      id: string;
      defaultMessage: string;
    }
  >,
): key is Key {
  return key in definitions;
}
